<template>
    <v-form v-model="valid" ref="form">
        <p class="body-1 grey--text text--darken-1 mt-4">
            {{ $t("label.yourCancel") }}
        </p>
        <v-card>
            <v-card-text>
                <p>{{ message }}</p>
                <v-layout row>
                    <v-flex>
                        <v-text-field
                            multi-line
                            v-model="form.comments"
                            auto-grow
                            :counter="constants.LENGTH_COMMENTS"
                            :maxlength="constants.LENGTH_COMMENTS"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row v-show="form.files.length > 0" class="mt-3">
                    <v-flex>
                        <app-files
                            :files.sync="form.files"
                            :removedFiles.sync="form.removedFiles"
                            :removeable="true"
                        ></app-files>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="success"
                    :loading="cancelling"
                    :disabled="cancelling"
                    @click="cancel"
                    >{{ $t("label.cancel") }}</v-btn
                >
                <app-file-upload
                    :disabled="cancelling"
                    :model.sync="form.files"
                ></app-file-upload>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    :loading="cancelling"
                    :disabled="cancelling"
                    @click="close"
                    >{{ $t("label.close") }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
import constants from "@/helpers/constants";
import FileUpload from "@/components/shared/FileUpload";
import Files from "@/components/shared/Files";
import Demand from "@/helpers/entities/Demand";

export default {
    props: {
        message: {
            type: String,
            required: true
        },
        isCancelling: {
            type: Boolean
        }
    },
    data() {
        return {
            constants,
            valid: true,
            cancelling: false,

            form: Demand.cancel.build()
        };
    },

    computed: {
        demand() {
            return this.$store.getters.demand;
        }
    },

    components: {
        appFileUpload: FileUpload,
        appFiles: Files
    },

    mounted() {
        this.form = Demand.cancel.copy(this.demand);
    },

    methods: {
        async cancel() {
            this.cancelling = true;
            await this.$store.dispatch("cancelDemand", this.form);
            this.$router.push({ name: "dashboard" });
        },
        close() {
            this.canceling = false;
            this.$emit("update:isCancelling", false);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/demands/shared/Cancel.vue